import type { Project, BankAccountsMap } from "../types";

const getBeneficiary = (bankAccountsMap: BankAccountsMap, project: Project): string => {
  const { bankAccountId } = project;

  if (!bankAccountId) {
    return "";
  }

  const bankAccount = bankAccountsMap[bankAccountId];

  if (!bankAccount) {
    return "";
  }

  const { beneficiaryName } = bankAccount;

  return beneficiaryName;
};

export default getBeneficiary;
